export const useMobileTemplatePreviewDimensions = ({ width, height }: { width: number; height: number }) => {
  const aspectRatio = width / height
  let itemWidth = 150
  let itemHeight = 150
  let twoByTwo = true
  let items = 4

  const windowWidth = window.innerWidth
  const containerWidth = windowWidth - 30

  if (aspectRatio > 1) {
    itemWidth = containerWidth
    itemHeight = containerWidth / aspectRatio
    twoByTwo = false
    items = 3
  } else {
    itemWidth = (containerWidth - 10) / 2
    itemHeight = containerWidth / aspectRatio
  }

  return {
    itemWidth,
    itemHeight,
    aspectRatio,
    twoByTwo,
    items,
  }
}
